import { SortProperty } from '../types/SortProperty';
import { SortDirection } from '../constants/SortDirection';

/**
 * Sorts table rows based on the given sort properties
 *
 * @param rows any[]
 * @param sortProperties SortProperty[]
 * @returns void
 */
export const sortRows = (rows: any[], sortProperties: SortProperty[]): void => {
  for (let index = sortProperties.length - 1; index > -1; index -= 1) {
    const { key, direction, defaultValue } = sortProperties[index];
    rows.sort(({ [key]: first }: any, { [key]: second }: any) => {
      const firstOrEmpty = (Array.isArray(first) ? first.join(',') : first) || defaultValue || '';
      const secondOrEmpty = (Array.isArray(second) ? second.join(',') : second) || defaultValue || '';

      if (direction === SortDirection.Asc) {
        return firstOrEmpty.localeCompare(secondOrEmpty);
      }

      return secondOrEmpty.localeCompare(firstOrEmpty);
    });
  }
};

/**
 * Sorts an array of objects based on a given prop. The sorting algorithm takes into account alphanumeric characters.
 * Returns undefined if objects param is not provided
 * Sorts by object if prop param is not provided
 *
 * @param objects any[]
 * @param prop string
 * @returns any[]
 */
export const sortObjectsByAlphanumericStrings = (objects?: any[], prop?: string): any[] | undefined => {
  if (!objects) {
    return objects;
  }
  const sortedObject = objects
    .slice(0)
    .sort((a, b) =>
      `${prop ? a[prop] : a}`.localeCompare(`${prop ? b[prop] : b}`, undefined, { numeric: true, sensitivity: 'base' }),
    );
  return sortedObject;
};
